<template>
  <div>
    <div>
      <div>
        <base-card>
          <base-label :text="StringLanguage.userInformation" class="mb_20" />
          <custom-form ref="userInformationForm">
            <name-input v-model="user.name" />
            <email-input v-model="user.email" :required="false" />
            <cellphone-input v-model="user.phone" :required="false" />
            <base-select :title="StringLanguage.permission" v-model="user.group" class="mb_5">
              <option :value="Role.ADMIN">{{ StringLanguage.administrator }}</option>
              <option :value="Role.ATENDENTE">{{ StringLanguage.employee }}</option>
            </base-select>
          </custom-form>
        </base-card>

        <base-card>
          <base-label :text="StringLanguage.accessData" class="mb_20" />
          <custom-form ref="accessDataForm">
            <username-input ref="username" v-model="user.username" :disabled="!!selectedUser.id" />
            <password-input v-model="user.password" :required="selectedUser.id ? false : true" />
          </custom-form>
        </base-card>
      </div>
    </div>
  </div>
</template>
<script>
import UserAPI from "@/api/user";
import AccountAPI from "@/api/account";
import { Role } from "easyjs/lib/Role/Group";
import User from "easyjs/lib/Schema/Account/User";

import BaseTitle from "@/components/Title";
import BaseButton from "@/components/Button";
import BaseCard from "@/components/Card";
import BaseInput from "@/components/Input";
import BaseSelect from "@/components/Select";
import BaseLabel from "@/components/Label";
import CustomForm from "@/containers/Form.vue";
import EmailInput from "../Inputs/EmailInput";
import NameInput from "../Inputs/NameInput";
import CellphoneInput from "../Inputs/CellphoneInput";
import UsernameInput from "../Inputs/UsernameInput";
import PasswordInput from "../Inputs/DoublePwInput";

import Utils from "@/utils";

export default {
  props: {
    selectedUser: {},
    userError: false,
  },
  data() {
    return {
      user: {
        group: Role.ADMIN,
        name: "",
        phone: "",
        username: "",
        password: {},
      },
      Role,
    };
  },
  created() {
    if (Object.keys(this.selectedUser).length > 0) {
      this.user = { ...this.selectedUser, password: {} };
    }
  },
  methods: {
    soe() {
      if (this.isInputsValid()) {
        if (this.selectedUser.id) {
          this.edit();
          return;
        }
        this.save();
      }
    },
    isInputsValid() {
      this.$refs.userInformationForm.validateInputs();
      this.$refs.accessDataForm.validateInputs();

      const isInputsValids = !this.$refs.userInformationForm.messages.length && !this.$refs.accessDataForm.messages.length;

      if (this.selectedUser.id) {
        return isInputsValids;
      }

      return isInputsValids;
    },
    async save() {
      if (await this.isUsernameAvaialble()) {
        const self = this;

        UserAPI.associate(self.user)
          .then((response) => {
            if (response.getErrors([]).length > 0) {
              alert(response.getErrors([])[0]);
            } else {
              this.user = {};
              self.$emit("newUser", response.getData({ create: null }));
            }
          })
          .catch((err) => {
            alert(StringLanguage.saveError);
          });
      }
    },
    isUsernameAvaialble() {
      return AccountAPI.isAccount(this.user.username, false).then((response) => {
        if (!!response.getData({ is_account: true }).is_account) {
          this.$refs.accessDataForm.setErrorValidation(this.$refs.username.inputId, "6005");
          this.$refs.username.isValid = false;
          return false;
        }

        return true;
      })
    },
    edit() {
      const user = { ...this.user };

      if (!user.password || Object.keys(user.password).length === 0) {
        delete user.password;
      }
      confirm(StringLanguage.confirmUpdateUser, (res) => {
        if (!res) return;
        UserAPI.update(user.id, user)
          .then((response) => {
            if (response.getErrors([]).length > 0) {
              alert(response.getErrors([])[0]);
            } else {
              this.$emit("editUser", response.getData({ create: null }));
            }
          })
          .catch((err) => {
            console.log(err);
            alert(StringLanguage.saveError);
          });
      });
    },
    del() {
      confirm(StringLanguage.confirmDisassociateUser, (res) => {
        if (!res) return;

        let self = this;
        UserAPI.disassociate(this.selectedUser.id).then((response) => {
          if (response._errors.length > 0) {
            alert(response._errors[0]);
          } else {
            alert("Usuário removido com sucesso!");
            self.$emit("userDeleted");
          }
        });
      });
    },
  },
  components: {
    BaseTitle,
    BaseButton,
    BaseCard,
    BaseInput,
    BaseSelect,
    BaseLabel,
    CustomForm,
    EmailInput,
    NameInput,
    CellphoneInput,
    UsernameInput,
    PasswordInput,
    Utils,
  },
};
</script>
